import config from "../../config"

export type Log = "debug" | "error" | "info"

export function setLogLvL() {
  const urlParams = new URLSearchParams(window.location.search)
  const logParam = urlParams.get("log") as Log | null

  if (logParam) {
    config.LOG_LEVEL = logParam
  }
}
